module.exports = __webpack_public_path__ + "static/media/double-tap.5351380c.svg";